import React, { Suspense, useEffect } from 'react';
import { useGetStandardAnalysisQuery } from '../../../../api/energy-analysis/calculateEnergySavingsApiSlice';
import { Box, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../../redux/snackbarSlice';


const StandardAnalysisDatagrid = React.lazy(() =>
    import('remote/StandardAnalysisDatagrid')
        .catch(() => ({
            default: () => <div>Failed to load</div>,
        }))
);

const StandardAnalysisTab = ({
  selectedAccount,
  selectedEnergyGroup,
  timeRange,
  setTimestampSummary,
}) => {
  
  const dispatch = useDispatch();

  //Query
  const { data, isLoading, isFetching, isSuccess, isError } = useGetStandardAnalysisQuery({
    accountId: selectedAccount?.AccountId,
    energyGroupId: selectedEnergyGroup?.energyGroupId,
    start: timeRange?.start,
    end: timeRange?.end,
  });


  useEffect(() => {
      if (isError) {
          dispatch(showSnackbar({ message: 'Standardanalysen kunne ikke vises', severity: 'error' }));
      }
  }, [isError])

  useEffect(() => {
    if (data?.TimestampsSummary) {
      setTimestampSummary(data.TimestampsSummary);
    }
  }, [data?.TimestampsSummary])


  return (
    <Box sx={{ height: "70vh" }}>
      <Suspense fallback={<CircularProgress/>}>
        <StandardAnalysisDatagrid
          initialRows={data?.StandardAnalysisData.map((item) => 
          {
            const energyNode = selectedEnergyGroup?.energyTreeNodes?.find(
              (group) => group.energyTreeNodeId === item.NodeId
            )
            return ({
            ...item,
            id: item.NodeId,
            Name: energyNode?.name,
            Type: energyNode?.type,
            icon: energyNode?.type,
          })
          })}
          isLoading={isFetching}
          selectedEnergyGroup={selectedEnergyGroup.options}
        />
      </Suspense>
    </Box>
  );
};

export default StandardAnalysisTab;